/**
 * build-flags.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

// Configure build-injected flags
declare var DEBUG : boolean;

declare var PRODUCTION : boolean;

export class BuildFlags {
  /**
   * Whether the app is in "debug mode", which may enable special features
   */
  public static debugMode : boolean = DEBUG || false;
  public static effectiveDebugMode : boolean = BuildFlags.debugMode;
  public static useProductionHostValues : boolean = !!PRODUCTION;
}

console.info(
  `Application is running in ${DEBUG ? "debug" : "standard"} mode for ` +
  `${PRODUCTION ? "nginx" : "simulated"} server`
);



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/configuration/build-flags.ts